import React from 'react';
export function PainPoints() {
  const points = ['Domingo a la noche buscando cómo bajar while, bucles anidados o funciones recursivas a un lenguaje que tus alumnos no ignoren.', 'Clases improvisadas porque los libros de texto tienen ejemplos desconectados de la realidad y los tutoriales de YouTube van demasiado rápido.', 'Alumnos "zombis" que solo esperan el timbre porque sienten que programar es para genios y ellos "nunca lo van a entender".', 'Evaluaciones fallidas porque todos copian código de Stack Overflow o piden el ejercicio resuelto a ChatGPT sin entender nada.', 'Horas perdidas armando ejercicios, buscando ejemplos, escribiendo consignas y creando evaluaciones que al final nadie termina.'];
  return <section className="py-3 md:py-4 px-3 bg-brand-dark" data-id="element-99">
      <div className="max-w-3xl mx-auto" data-id="element-100">
        <h2 className="text-base md:text-xl font-bold text-center mb-2 text-white leading-tight uppercase tracking-tight" data-id="element-101">
          Si sos profesor de Programación o Tecnología, esto te va a sonar
          familiar:
        </h2>

        <div className="bg-brand-card border-l-4 border-red-400/60 rounded-r-xl p-3 mb-3" data-id="element-102">
          <div className="space-y-2" data-id="element-103">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-104">
                <span className="text-red-400 mr-2 shrink-0 text-sm" data-id="element-105">❌</span>
                <p className="text-xs md:text-sm text-gray-300 font-normal leading-relaxed" data-id="element-106">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-107">
          <h3 className="text-sm md:text-lg font-semibold text-white leading-snug uppercase tracking-tight" data-id="element-108">
            ¿Cuántos fines de semana más vas a perder intentando "descifrar"
            cómo enseñar lógica de programación a adolescentes que nunca
            escribieron una línea de código?
          </h3>
        </div>
      </div>
    </section>;
}